import React from 'react';
import BannerAndStaticHTML from '../../components/Banner/BannerAndStaticHTML';
import BannerCarousel from '../../components/Carousel/BannerCarousel';
import CategoryCarousel from '../../components/Carousel/CategoryCarousel';
import CollapsibleTabs from '../../components/Banner/LoadableCollapsibleTabs';
import ErrorBoundary from '../../components/ErrorBoundaries/ErrorBoundary';
import YotpoWidgets from '../../components/YotpoWidgets/LoadableYotpoWidgets';
const BannerAndCarouselRenderer = props => {
    const { componentsData, isYotpoWidgets } = props;
    return (
        <div className="component">
            {
                componentsData && componentsData.map((item, idx) => {
                    const cols = (12 / item.data.length);
                    const colClass = `col-sm-${cols} col-md-${cols} col-lg-${cols}`;
                    const style = {
                        paddingBottom: item.bottomSpace ? `${item.bottomSpace}px` : '0px'
                    };
                    return (
                        <div key={`section-comp-${idx}`} className="row section-component" attribute-index={idx + 1} >
                            {
                                item.data.map((comp, index) => {
                                    if (comp.type === 'TYPE_BANNER_CAROUSEL') {
                                        return (
                                            <ErrorBoundary key={`error-comp-${index}`} errorMessage="Got an error...">
                                                <BannerCarousel key={`banner-carousel-${index}`} bannerCarouselData={comp.data} verticalPosition={idx + 1} className={colClass} style={style} />
                                            </ErrorBoundary>
                                        );
                                    } if (comp.type === 'TYPE_BANNER' || comp.type === 'TYPE_STATIC_HTML') {
                                        return (
                                            <ErrorBoundary key={`error-comp-${index}`}>
                                                <BannerAndStaticHTML key={`banner-${index}`} id={`banner-${index}`} bannerData={comp.data} verticalPosition={idx + 1} className={colClass} style={style} />
                                            </ErrorBoundary>
                                        );
                                    } if (comp.type === 'TYPE_CATEGORY_CAROUSEL') {
                                        return (
                                            <ErrorBoundary key={`error-comp-${index}`}>
                                                <CategoryCarousel key={`category-carousel-${index}`} categoryCarouselData={comp.data} categoryData={comp.productData} style={style} />
                                            </ErrorBoundary>
                                        );
                                    } if (comp.type === 'TYPE_COLLAPSIBLE_TABS') {
                                        return (
                                            <ErrorBoundary key={`error-comp-${index}`}>
                                                <CollapsibleTabs key={`collapsible-tabs-${index}`} tabsData={comp.data} className={colClass} style={style} />
                                            </ErrorBoundary>
                                        );
                                    } if (comp.type === 'TYPE_YOTPO_INSTAGRAM' && isYotpoWidgets) {
                                        return (
                                            <YotpoWidgets key={`instagram-${index}`} className={`${colClass} margin-t20 padding-l30 padding-r30`} style={style} widgets={['instagram']} redisKey="home" galleryKey="home" galleryTitle="Shop from our Instagram" galleryBtnText="Explore More" dtmPage="home" dtmPageType="homepage" />
                                        );
                                    }
                                    return <div key={index}></div>;
                                })
                            }
                        </div>
                    );
                })
            }
        </div>
    );
};

export default BannerAndCarouselRenderer;
